import { TextM, TextMS, TextSS } from "../../common/text";
import {
  Button,
  ButtonWrapper,
  Title,
  PosterImg,
  TitleWrapper,
  PosterWrapper,
  ButtonIcon,
  NavContainer,
  NavWrapper,
  LogOutIcon,
  MyTicketIcon,
} from "./Welcome.styles";
import { useNavigate } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.esm.browser";
import "swiper/components/pagination/pagination.min.css";
import { Helmet } from "react-helmet";

import WelcomeBottomSheet from "./WelcomeBottomSheet";
import { useAdvertisements } from "./Welcome.helpers";
import { Background } from "../../common/components";
import { useMediaQuery } from "react-responsive";
import useFcmProcess from "../../fcmProcess";
import { isIOS as isios } from "react-device-detect";
import { logout } from "../../api/auth";
import { useSetRecoilState } from "recoil";
import { authAtom } from "../../recoil/atoms";

const empty = process.env.PUBLIC_URL + "/dummyImages/emptyAdvertise.png";

const Welcome = () => {
  const navigate = useNavigate();
  const setAuthAtom = useSetRecoilState(authAtom);
  // 티켓 조회 정보 창
  // const [isReigeterOpen, setIsReigeterOpen] = useState(true);

  useFcmProcess(); // fcm 토큰 발급 및 구독 등

  const { data: advertisements, isLoading, isSuccess } = useAdvertisements();
  const isTablet = useMediaQuery({ query: "(min-width: 768px)" });

  const goToMyTickets = () => {
    navigate("/my-tickets");
  };

  const onClickLogout = () => {
    logout();
    setAuthAtom({ isLoggedIn: false, username: null, name: null });
  };
  SwiperCore.use([Pagination, Autoplay]);

  return (
    <Background style={{ alignItems: "center" }}>
      <Helmet>
        <title>넥스트에너지</title>
      </Helmet>

      <TitleWrapper>
        <Title>What is your next energy?</Title>
      </TitleWrapper>

      <PosterWrapper
        spaceBetween={8}
        initialSlide={1}
        centeredSlides={true}
        pagination={{
          clickable: true,
        }}
        autoplay={{ delay: 3000 }}
        watchOverflow={false}
        isios={isios.toString()}
      >
        {!isLoading &&
          isSuccess &&
          (advertisements.length === 0 ? (
            <SwiperSlide>
              <PosterImg src={empty} />
            </SwiperSlide>
          ) : (
            advertisements.map(
              ({ pk, mobileImageUrl, tabletImageUrl, dynamicLink }) => (
                <SwiperSlide key={pk}>
                  <a href={dynamicLink}>
                    {
                      <PosterImg
                        src={isTablet ? tabletImageUrl : mobileImageUrl}
                      />
                    }
                  </a>
                </SwiperSlide>
              )
            )
          ))}
      </PosterWrapper>

      <NavContainer isios={isios}>
        <NavWrapper onClick={goToMyTickets}>
          <MyTicketIcon />
          <TextSS>구매내역</TextSS>
        </NavWrapper>
        <NavWrapper onClick={onClickLogout}>
          <LogOutIcon />
          <TextSS>로그아웃</TextSS>
        </NavWrapper>
      </NavContainer>
    </Background>
  );
};

export default Welcome;
